import icon from 'vue-svgicon';

icon.register({
    'light/award-ribbon-star-3': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<path pid="0" d="M16 18.144v4.58c0 .55-.318.682-.707.293L12 19.724l-3.293 3.293c-.389.389-.707.257-.707.128v-5M11.776 5.838c.123-.246.324-.246.447 0l.942 1.886H15c.275 0 .319.134.1.3l-1.546 1.142.637 2.184c.077.264-.05.359-.281.211L12 10.342l-1.91 1.181c-.234.145-.361.049-.282-.216l.636-2.135L8.9 8.023c-.221-.164-.176-.3.1-.3h1.833z" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><circle pid="1" cx="12" cy="8.724" r="8" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/><circle pid="2" cx="12" cy="8.724" r="5.5" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round"/>`,
    },
});
